import { BuildingModel } from './building.model';
import { QuestionnaryModel } from './questionnary.model';
import { AnswerModel } from './answer.model';

import { environment } from '../../../environments/environment';

export class DiagnosticModel
{
	id: number = undefined;
	building: BuildingModel = new BuildingModel(null);
	questionnary: QuestionnaryModel = new QuestionnaryModel(null);
	date: string = undefined;

	ratio: number = 0;
	note: number = 0;

	rapport: string = '';
	finished: boolean = false;


	// complété dynamiquement dans synthesis
	previousNote: number = undefined;
	importantRisks: Array<AnswerModel> = [];

	get auditName()
	{
		return this.questionnary.name.replace('Questionnaire','Audit');
	}

	get pdfUrl()
	{
		if(this.rapport=='API-PDF' || this.rapport=='API') 
	      return environment.apiBaseUrl+'/report-pdf/'+this.id
	              +'?mode=pdf&token='+localStorage.getItem('access_token');
	    
	    return '';
	}


	constructor(values) {
		this.exchange(values, false);
	}
	
	exchange(values: Object = {}, isObject=false) {
	    for (let p in values) {
	    	
		    if (this.hasOwnProperty(p) && values.hasOwnProperty(p)) {
		    	if(p == 'id' && this.id != undefined) {
		    		continue;
		    	}
		    	else {
		    		if(isObject) this[p].exchange(values[p]);
		    		else this[p] = values[p];
		    		
		    	} 
		    }
		    else if (p == '_embedded') {
	    		this.exchange(values[p], true);
	    	} else {
	    		
	    	}
		  }
	}

	toString()
	{
		return "diagnostic.model "+this.id;
	}
}